export function isOneOf<const Option extends string>(
  options: readonly Option[],
  value: string | null | undefined,
): value is Option {
  return typeof value === "string" && options.some((option) => option === value);
}

export function narrowToOneOf<const Option extends string>(
  options: readonly Option[],
  value: string | null | undefined,
): Option | undefined {
  return isOneOf(options, value) ? value : undefined;
}

export function selectOneOf<const Option extends string>(
  options: ReadonlyArray<{ value: Option }>,
  onSelect: (value: Option) => void,
): (value: string) => void {
  return (value) => {
    const match = options.find((option) => option.value === value)?.value;
    if (match) onSelect(match);
  };
}
